export const initHeader = () => {
  const header = document.querySelector(".site-header") as HTMLElement;

  /**
   * Lock Scroll to current position
   */
  let scrollLocked = false;
  let scrollPosition: number | null = null;

  const lockScroll = () => {
    if (!scrollLocked) {
      scrollPosition = window.scrollY;
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      scrollLocked = true;
    }
  };

  const unlockScroll = () => {
    if (scrollLocked) {
      document.body.style.overflow = 'auto';
      document.body.style.position = 'static';
      document.body.style.top = 'auto';
      if (scrollPosition !== null) {
        window.scrollTo(0, scrollPosition);
        scrollPosition = null;
      }
      scrollLocked = false;
    }
  };

  const toggleScrollLock = () => {
    if (scrollLocked) {
      unlockScroll();
    } else {
      lockScroll();
    }
  };

  /**
   * Mobile Navigation
   */
  const navToggle = document.querySelector("#nav-toggle");

  navToggle.addEventListener("click", (e) => {
    document.body.classList.toggle("scroll--disabled");

    header.classList.toggle("mobile-nav--open");
    navToggle.classList.toggle("nav-toggle--active");

  });


  /**
 * Window Scroll Header
 */
  window.onscroll = () => {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
      header.classList.add("scrolled");
      document.body.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
      document.body.classList.remove("scrolled");
    }
  };

  /**
   * Toggle Saved Recipes Container
   */
  const savedRecipesListToggle: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.recipes-toggle');
  const savedRecipesList: HTMLElement = document.querySelector(".saved-recipes-section");
  const overlay: HTMLElement = document.getElementById('body-overlay-id');
  const overlayHeader: HTMLElement = document.querySelector('.header-overlay');

  const toggleOverlay = (): void => {
    if (overlay.style.display == 'block') {
      overlay.style.display = 'none';
      overlayHeader.style.display = 'none';
    } else {
      overlay.style.display = 'block';
      overlayHeader.style.display = 'block';
    }
  };

  // Event listener for the "ESC" key press
  document.addEventListener("keydown", (event: KeyboardEvent) => {
    if (event.key == "Escape" || event.key === "Esc") {
      savedRecipesList.classList.remove("saved-recipes-section--open");
      overlay.style.display = 'none';
      overlayHeader.style.display = 'none';
      // toggleScrollLock();
    }
  });

  savedRecipesListToggle.forEach(button => {
    button.addEventListener("click", () => {
      savedRecipesList.classList.toggle("saved-recipes-section--open");
      toggleOverlay();
      // toggleScrollLock();
    });
  });

  /**
   * Check the amount of links per item in Desktop-dropdowns,
   * If the amount of links are more than X, add a span-attribute (scss) to the item so the item takes up 2 slots on the grid instead of one.
   */
  type DropdownItem = HTMLElement | null;

  const adjustGridSpan = () => {
    const sublinkContainers = document.querySelectorAll<HTMLElement>('.sublinks');

    sublinkContainers.forEach((container) => {
      const sublinksLinks = container.querySelectorAll<HTMLElement>('.sublinks__link');

      if (sublinksLinks.length > 5) {
        const dropdownItem = container.closest<DropdownItem>('.dropdown__item');
        if (dropdownItem) {
          dropdownItem.classList.add('grid-span-2');
        }
      }
    });
  };

  const checkDropdownsAndAddClass = () => {
    const dropdowns = document.querySelectorAll<HTMLElement>('.dropdown');

    dropdowns.forEach((dropdown) => {
      const dropdownItems = dropdown.querySelectorAll('.dropdown__item');

      dropdownItems.forEach((dropdownItem) => {
        const sublinkLinks = dropdownItem.querySelectorAll('.sublinks__link');

        if (sublinkLinks.length === 0) {
          const dropdownList = dropdown.querySelector<HTMLElement>('.dropdown__list');

          if (dropdownList) {
            dropdownList.classList.add('no-grid');
          }
        }
      });
    });
  };

  const checkSublinkItems = () => {
    // Select all elements with the class ".sublink"
    const sublinks: NodeListOf<HTMLElement> = document.querySelectorAll(".sublinks");

    // Iterate through each ".sublink" element
    sublinks.forEach((sublink: HTMLElement) => {
      // Select all elements with the class ".sublinkks__item" inside the current ".sublink"
      const sublinkItems: NodeListOf<HTMLElement> = sublink.querySelectorAll(".sublinks__item");

      // Check if there are more than x ".sublinkks__item" elements
      if (sublinkItems.length > 9) {
        sublink.classList.add("more-than-x");
      }
    });
  };

  const addClassToLastItem = () => {
    const dropdowns = document.querySelectorAll<HTMLElement>('.dropdown');
  
    dropdowns.forEach((dropdown) => {
      const dropdownItems = Array.from(dropdown.querySelectorAll('.dropdown__item'));
  
      if (dropdownItems.length >= 2) {
        const lastItem = dropdownItems[dropdownItems.length - 1];
        const nextToLastItem = dropdownItems[dropdownItems.length - 2];
  
        if (!lastItem.classList.contains('grid-span-2')) {
          lastItem.classList.add('last-item');
        }
        if (!nextToLastItem.classList.contains('grid-span-2')) {
          nextToLastItem.classList.add('last-item');
        }
      }
    });
  };

  // Call the function when the document is ready
  document.addEventListener('DOMContentLoaded', () => {
    adjustGridSpan();
    checkDropdownsAndAddClass();
    checkSublinkItems();
    addClassToLastItem();
  });
}